// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23 1H1V23H23V1ZM18.75 6H7.5V3.75L3.75 6.75L7.5 9.75V7.5H18V12H19.5V6.75C19.5 6.55109 19.421 6.36032 19.2803 6.21967C19.1397 6.07902 18.9489 6 18.75 6ZM5.25 18H16.5V20.25L20.25 17.25L16.5 14.25V16.5H6V12H4.5V17.25C4.5 17.4489 4.57902 17.6397 4.71967 17.7803C4.86032 17.921 5.05109 18 5.25 18Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
